import { type FC } from 'react';
import { Box, Flex, Heading, Image } from '@chakra-ui/react';

import {
  getHeading,
  isAccountant,
  isEmployee,
} from 'layouts/AuthentificationLayout/utils';
import { type InvitationInfo } from 'types/invitation';

import accountantImg from '../../assets/accountant.png';
import appImg from '../../assets/app.png';
import EmployeeFeatures from '../EmployeeFeatures';

interface FeaturesPresentationProps {
  invitation: Pick<InvitationInfo, 'role'> | null;
}

export const FeaturesPresentation: FC<FeaturesPresentationProps> = ({
  invitation,
}) => {
  const heading = getHeading(invitation?.role);

  const renderMainContent = () => {
    if (isEmployee(invitation?.role)) {
      return <EmployeeFeatures />;
    }

    if (isAccountant(invitation?.role)) {
      return <Image alt="" role="presentation" src={accountantImg} />;
    }

    return <Image alt="" role="presentation" src={appImg} />;
  };

  return (
    <Box
      alignItems="center"
      backgroundColor="grey.200"
      display={{ base: 'none', md: 'flex' }}
      flex={1}
      flexDirection="column"
      gap="space-40"
      justifyContent="center"
    >
      <Heading marginX="auto" maxWidth="60%" size="xl">
        {heading}
      </Heading>

      <Flex
        justifyContent="center"
        marginX="auto"
        maxWidth="1024px"
        width="90%"
      >
        {renderMainContent()}
      </Flex>
    </Box>
  );
};
